<template>
  <div class="md-layout">
    <div class="md-layout-item md-medium-size-100 md-size-100">
      <program-edit-form ref="program-edit-form" header-color="green">
      </program-edit-form>
    </div>
  </div>
</template>
<script>
import ProgramEditForm from "./ProgramUpdateComponent/ProgramEditForm";

export default {
  components: {
    ProgramEditForm
  },
  mounted() {
    this.programID = this.$route.params.id;
    this.$store.getProgram(this.programID).then(response => {
      this.$refs["program-edit-form"].name = response.data.name;
      this.$refs["program-edit-form"].university = response.data.university.id;
      this.$refs["program-edit-form"].application_autumn_start_date =
        response.data.application_autumn_start_date;
      this.$refs["program-edit-form"].application_autumn_end_date =
        response.data.application_autumn_end_date;
      this.$refs["program-edit-form"].application_spring_start_date =
        response.data.application_spring_start_date;
      this.$refs["program-edit-form"].application_spring_end_date =
        response.data.application_spring_end_date;
      this.$refs["program-edit-form"].lesson_start_date =
        response.data.lesson_start_date;
      // Type
      if (response.data.type === "Associate degree") {
        this.$refs["program-edit-form"].type = 1;
      } else if (response.data.type === "Bachelor degree") {
        this.$refs["program-edit-form"].type = 2;
      } else if (response.data.type === "Master Non-Thesis") {
        this.$refs["program-edit-form"].type = 3;
      } else if (response.data.type === "Master With Thesis") {
        this.$refs["program-edit-form"].type = 4;
      } else {
        this.$refs["program-edit-form"].type = 5;
      }

      this.$refs["program-edit-form"].price = response.data.price;
      this.$refs["program-edit-form"].discounted_price =
        response.data.discounted_price;
      this.$refs["program-edit-form"].commission = response.data.commission;
      this.$refs["program-edit-form"].fix_commission_price =
        response.data.fix_commission_price;
      this.$refs["program-edit-form"].student_fix_commission_price =
        response.data.student_fix_commission_price;
      this.$refs["program-edit-form"].currency = response.data.currency;
      this.$refs["program-edit-form"].turkish_preparation = response.data.extras.turkish_preparation;
      this.$refs["program-edit-form"].english_preparation = response.data.extras.english_preparation;
      this.$refs["program-edit-form"].german_preparation = response.data.extras.german_preparation;
      this.$refs["program-edit-form"].arabic_preparation = response.data.extras.arabic_preparation;
      this.$refs["program-edit-form"].french_preparation = response.data.extras.french_preparation;
      this.$refs["program-edit-form"].russian_preparation = response.data.extras.russian_preparation;
      this.$refs["program-edit-form"].spanish_preparation = response.data.extras.spanish_preparation;
      this.$refs["program-edit-form"].chinese_preparation = response.data.extras.chinese_preparation;
      this.$refs["program-edit-form"].chinese_preparation = response.data.extras.chinese_preparation;
      this.$refs["program-edit-form"].cash_payment_discount = response.data.extras.cash_payment_discount;
      this.$refs["program-edit-form"].sibling_discount = response.data.extras.sibling_discount;
      // Scope
      if (response.data.scope === "Term") {
        this.$refs["program-edit-form"].scope = 1;
      } else if (response.data.scope === "Yearly") {
        this.$refs["program-edit-form"].scope = 2;
      } else {
        this.$refs["program-edit-form"].scope = 3;
      }
      // Education Duration
      if (response.data.education_duration === "1 year") {
        this.$refs["program-edit-form"].education_duration = 0;
      } else if (response.data.education_duration === "1.5 year") {
        this.$refs["program-edit-form"].education_duration = 1;
      } else if (response.data.education_duration === "2 years") {
        this.$refs["program-edit-form"].education_duration = 2;
      } else if (response.data.education_duration === "3 years") {
        this.$refs["program-edit-form"].education_duration = 3;
      } else if (response.data.education_duration === "4 years") {
        this.$refs["program-edit-form"].education_duration = 4;
      } else if (response.data.education_duration === "5 years") {
        this.$refs["program-edit-form"].education_duration = 5;
      } else if (response.data.education_duration === "6 years") {
        this.$refs["program-edit-form"].education_duration = 6;
      } else {
        this.$refs["program-edit-form"].education_duration = 7;
      }
      this.$refs["program-edit-form"].quota = response.data.quota;
      // Education Type
      if (response.data.education_type === "Full time") {
        this.$refs["program-edit-form"].education_type = 1;
      } else if (response.data.education_type === "Evening Period") {
        this.$refs["program-edit-form"].education_type = 2;
      } else {
        this.$refs["program-edit-form"].education_type = 3;
      }
      // Campus Type
      if (response.data.campus_type === "On campus") {
        this.$refs["program-edit-form"].campus_type = 1;
      } else {
        this.$refs["program-edit-form"].campus_type = 2;
      }
      // Status
      if (response.data.status === "Full Active") {
        this.$refs["program-edit-form"].status = 1;
      } else if (response.data.status === "Active") {
        this.$refs["program-edit-form"].status = 2;
      } else if (response.data.status === "Inactive") {
        this.$refs["program-edit-form"].status = 3;
      }
      this.$refs["program-edit-form"].education_language =
        response.data.education_language;
      if (response.data.city) {
        this.$refs["program-edit-form"].city = response.data.city.id;
      }
      this.$refs["program-edit-form"].address = response.data.address;
      this.$refs["program-edit-form"].website = response.data.website;
      this.$refs["program-edit-form"].deadline = response.data.deadline;
      this.$refs["program-edit-form"].detail = response.data.detail;
      this.$refs["program-edit-form"].modules = response.data.modules;
      this.$refs["program-edit-form"].admission_and_fees =
        response.data.admission_and_fees;
      this.$refs["program-edit-form"].installments = response.data.installments;
      this.$refs["program-edit-form"].deposit = response.data.deposit;
      this.$refs["program-edit-form"].refund_policy =
        response.data.refund_policy;
      this.$refs["program-edit-form"].is_quota_full =
        response.data.is_quota_full;
      this.$refs["program-edit-form"].notes = response.data.notes;
      var requirements = [];
      for (const item in response.data.requirements) {
        requirements.push(response.data.requirements[item].toString());
      }
      this.$refs["program-edit-form"].requirements = requirements;
    });
  }
};
</script>
